import { section } from "@/glow";
import truncateWrapper from "@/lib/truncate-wrapper";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("testimonials", {
  onLoad() {
    this.truncateWrapper = truncateWrapper(this.container);

    if (shouldAnimate(this.container)) {
      this.itemAnimations = animateStandard(this.container);
    }
  },

  onUnload() {
    this.truncateWrapper?.unload();
    this.animateApps?.destroy();
  },
});
